import * as React from 'react';
import styled from 'styled-components';

import { Line } from '../ui/divider/Line';
import { H1 } from './HeaderTitle';
import { TextContainer } from './TextContainer';
import { Container } from './Container';
import { Maybe } from '../../../client/types/generated/types';

// Nyhetsartikkel side
export const NewsArticleStyle = styled.div<any>`
  background-color: ${({ theme, hidebackground }) =>
    hidebackground ? 'transparent' : theme.colors.burgundy};
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0px;
  padding: ${({ title }) => (title ? '3em 1em 1em 1em' : '1em')};
  &:last-child {
    padding: ${({ title }) => (title ? '3em 1em 3em 1em' : '1em')};
  }
  h2 {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.white};
    margin-top: 2em;
    width: 100%;
    max-width: 33em;
    text-align: center;
    font-weight: 300;
    padding: 0 30px;
  }
  .ingress {
    font-size: 22px;

    p {
      font-size: 22px;
      width: 100%;
      max-width: 41em !important;
    }
  }
  .date {
    margin-bottom: 2em;
  }

  @media all and (max-width: 375px) {
    .ingress {
      font-size: 20px !important;
      p {
        padding: 0px 1em;
      }
    }
  }
`;

export const NewsArticle: React.FC<{
  hidedivider?: boolean;
  hidebackground?: boolean;
  link?: Maybe<string> | undefined;
  date?: string;
  title?: Maybe<string> | undefined;
  ingress?: Maybe<string> | undefined;
  url?: string;
  info: Maybe<string> | undefined;
}> = ({
  hidebackground,
  children,
  link,
  hidedivider,
  date,
  title,
  ingress,
  info,
}) => {
  return (
    <Container>
      <NewsArticleStyle title={title} hidebackground={hidebackground}>
     {/*    {date ? <p className="date">{date}</p> : null} */}
       <div style={{margin:'31px 0 32px'}}></div>
        {title ? <H1>{title}</H1> : null}
        {!hidedivider ? <Line /> : null}
        {ingress ? (
          <p
            className="ingress"
            dangerouslySetInnerHTML={{ __html: ingress }}
          />
        ) : null}
        {info ? <TextContainer text={info} /> : null}
        {children}
      </NewsArticleStyle>
    </Container>
  );
};
